export enum DateRangeType {
    COVERAGE_EFFECTIVE = 'COVERAGE_EFFECTIVE',
    DATE_OF_DISABILITY = 'DATE_OF_DISABILITY',
    BENEFITS = 'BENEFITS',
    PREEXISTING_REVIEW = 'PREEXISTING_REVIEW',
    TREATMENT_FREE = 'TREATMENT_FREE',
    OWN_OCCUPATION_PERIOD_END_DATE = 'OWN_OCCUPATION_PERIOD_END_DATE'
}